
import { AxiosInstance } from "axios"
import api from "@/services/api"
import { DashboardSummary, Dashboard } from "@/types"

class DashboardApi {
	private get axios (): AxiosInstance {
		return api.getAxios()
	}

	public async dashboardGetList (): Promise<DashboardSummary[]> {
		return (await this.axios.get("/dashboard")).data
	}

	public async dashboardGetListForTeam (teamId: string): Promise<DashboardSummary[]> {
		return (await this.axios.get(`/dashboard/forteam/${teamId}`)).data
	}

	public async dashboardGet (dashboardId: string): Promise<Dashboard> {
		return (await this.axios.get(`/dashboard/${dashboardId}`)).data
	}

	public async dashboardSave (dashboard: Dashboard): Promise<Dashboard> {
		return (await this.axios.post("/dashboard", dashboard)).data
	}

	public async dashboardDelete (dashboardId: string): Promise<void> {
		await this.axios.delete(`/dashboard/${dashboardId}`)
	}
}

const dashboardApi = new DashboardApi()
export default dashboardApi
